.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_vy_1j4awkz{width:130px;}
.atm_h0_ftgil2.atm_h0_ftgil2{margin-right:8px;}
.atm_gz_ftgil2.atm_gz_ftgil2{margin-left:8px;}
.atm_gi_ftgil2{margin:8px;}
